module.exports = __webpack_public_path__ + "img/service_webdev.8f7b9d7b.jpg";